import {useMutation, useQueryClient} from '@tanstack/react-query';
import {message} from 'antd';
import {fileService} from '../services/file';
import type {UpdateFileMetaParams} from '../types/file';

export const useUpdateFileMeta = (currentId?: number | string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateFileMetaParams) => {
      return data.type === 'file'
        ? fileService.updateFileMeta(data)
        : fileService.updateFolderPermission({
          id: data.id,
          visibility: data.visibility
        });
    },

    onMutate: async (data: UpdateFileMetaParams) => {
      await queryClient.cancelQueries({
        queryKey: ['file-list', currentId]
      });

      const previousData = queryClient.getQueryData<any>(['file-list', currentId]);

      queryClient.setQueryData(['file-list', currentId], (old: any) => {
        if (!old) return old;

        return {
          ...old,
          pages: old.pages.map((page: any) => {
            return {
              ...page,
              items: page.items.map((item: any) =>
                item.id === data.id
                  ? {
                    ...item,
                    ...data
                  }
                  : item
              )
            };
          })
        };
      });

      return {previousData};
    },

    onError: (_err, _data, context: any) => {
      if (context?.previousData) {
        queryClient.setQueryData(['file-list', currentId], context.previousData);
      }
      void message.error('更新失败,已回滚');
    },

    onSettled: () => {
      if (!currentId) return;

      void queryClient.invalidateQueries({
        queryKey: ['file-list', currentId]
      });
    }
  });
};
